module.exports = __webpack_public_path__ + "img/bni.f1b999c2.png";